export default "__VITE_ASSET__9fd29dd6__"